import React from 'react'
import { Tooltip } from 'react-tippy'

import { Text } from '../../../topography'
import { fonts, palette } from '../../../../styles/variables'
import { translate } from '../../../../utils/translation'

import { TurnstileTooltipWrapper } from './styled'

/**
 * Renders a customizable tooltip for a turnstile element, enhancing user interaction and feedback.
 * This component acts as a wrapper for any child elements, overlaying a tooltip with a specified message and control state.
 */
export const TurnstileTooltip = React.memo(
  ({ message, open, methods, button: { method, text }, children }) => {
    return (
      <Tooltip
        arrow
        open={open}
        position="top"
        zIndex={10001}
        html={
          <TurnstileTooltipWrapper>
            <Text
              fontFamily={fonts.primaryBook}
              fontSize="16px"
              lineHeight="18px"
              textAlign="center"
              color={palette.white}
              boldFontFamily={fonts.primaryBook}
              dangerouslySetInnerHTML={{
                __html: translate(message),
              }}
            />
            {/* Conditionally renders a button based on the presence of method and text properties */}
            {text && methods && method && methods[method] ? (
              <button
                type="button"
                className="tippy-touch"
                onClick={() => {
                  methods[method]()
                }}
              >
                {translate(text)}
              </button>
            ) : null}
          </TurnstileTooltipWrapper>
        }
      >
        {children}
      </Tooltip>
    )
  },
)

TurnstileTooltip.defaultProps = {
  message: '', // Default message to be displayed in the tooltip
  open: false, // Controls the visibility of the tooltip
  turnstileStatus: { methods: {} }, // Methods available for triggering actions within the tooltip
  button: { method: '', text: '' }, // Optional button within the tooltip, with a method to execute on click
}
